import { http } from '@/services'

export const trainingService = {
    getTraining: (id) => {
        let url = 'training';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setTraining: (training) => {
        return http.post('training/' + training.id, training)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    deleteTraining: (training) => {
        return http.delete('training/' + training.id)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getTrainingCache: () => {
        return http.get('training/cache')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getTrainingDocument: (type) => {
        return http.get('training/document/' + type)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getTrainingMap: () => {
        return http.get('training/map')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getTrainingFile: (file) => {
        // use the current url location to reference policy file (don't downloaded using api domain)
        let url = window.location.protocol + '//' + window.location.host + '/' + file;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
}